import React, { useEffect, useState } from 'react';
import { Button, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, IconButton, Radio, RadioGroup, Box, Typography } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { RepLIProviderTextField } from '../../../components';
import { AppSelect } from './ProviderInputComponents';
import { arrayOfNumbers } from '../../../services/util.service';
import useStyles from "./Common.style";

const PatientPregnancyInformationForm = props => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [autoUpdate, setAutoUpdate] = useState(false);

    let birthYear = new Date(props.dateOfBirth).getFullYear();
    let firstPeriodAge = parseInt(props.firstPeriodAge);
    let firstPeriodYear = firstPeriodAge ? birthYear + firstPeriodAge : null;
    let currentYear = new Date(Date.now()).getFullYear();
    let pregnancyYears = firstPeriodYear
        ? [...arrayOfNumbers(firstPeriodYear, currentYear - firstPeriodYear + 1)]
        : [];
    let providerViewPregnancies = 0;

    useEffect(() => {
        if (props.submitted) props.validator.showMessages();
        props.validator.purgeFields();
        setAutoUpdate(!autoUpdate);
    }, [props.submitted, props.validator, props.pregnancies]);


    return (
        <Grid container className={classes.questionnaireContainer}>
            {props.pregnancies.map((pregnancy, i) => {
                return (
                    (pregnancy.isProviderView == 'true' && props.mode != 'create') || props.mode == 'create' ?
                        < Grid container spacing={1} className={classes.questionnaireItem} key={i} >
                            <Grid item xs={12} className={classes.questionnaireItemHeader}>
                                <span>{t('common.substantive.pregnancy')} #  {providerViewPregnancies = providerViewPregnancies + 1}</span>
                                <IconButton aria-label="delete" color="inherit" onClick={props.onPregnancyDelete(i)}>
                                    <DeleteIcon />
                                </IconButton>
                            </Grid>
                            <Grid item xl={4} md={6} className={classes.appSelectGridItem}>
                                <AppSelect
                                    id={`pregnancy${i + 1}`}
                                    label={`${t('common.substantive.year')}*`}
                                    value={pregnancy.year}
                                    items={pregnancyYears}
                                    onChange={props.onDataChange(i, 'year')}
                                    fullWidth
                                    error={props.submitted && !props.validator.fieldValid(`pregnancy_#${i + 1}_year`)}
                                    helperText={props.validator.message(`pregnancy_#${i + 1}_year`, pregnancy.year, 'required')}

                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl
                                    component="fieldset"
                                    error={props.submitted && !props.validator.fieldValid(`pregnancy_#${i + 1}_intention`)}
                                >
                                    <FormLabel className={classes.formLabelStyle}>{`${t('common.substantive.intention')}*`}</FormLabel>
                                    <RadioGroup row aria-label="preganancyIntentions" value={pregnancy.intention} onChange={props.onDataChange(i, 'intention')}>
                                        <FormControlLabel value="Intended" control={<Radio color="primary" />}
                                            label={t('repliQuestionnaire.label.intention.intended')} />
                                        <FormControlLabel value="Unintended" control={<Radio color="primary" />}
                                            label={t('repliQuestionnaire.label.intention.unintended')} />
                                    </RadioGroup>
                                    <FormHelperText>
                                        {props.validator.message(`pregnancy_#${i + 1}_intention`, pregnancy.intention, `required`)}
                                    </FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl
                                    component="fieldset"
                                    error={props.submitted && !props.validator.fieldValid(`pregnancy_#${i + 1}_outcome`)}
                                >
                                    <FormLabel className={classes.formLabelStyle}>{`${t('common.substantive.outcome')}*`}</FormLabel>
                                    <RadioGroup row aria-label="preganancyOutcome" value={pregnancy.outcome} onChange={props.onOutcomeDataChange(i)}>
                                        <FormControlLabel value="Live Birth" control={<Radio color="primary" />}
                                            label={t('repliQuestionnaire.label.outcome.liveBirth')} />
                                        <FormControlLabel value="Miscarriage" control={<Radio color="primary" />}
                                            label={t('repliQuestionnaire.label.outcome.miscarriage')} />
                                        <FormControlLabel value="Ectopic or Tubal" control={<Radio color="primary" />}
                                            label={t('repliQuestionnaire.label.outcome.ectopicTubal')} />
                                        <FormControlLabel value="Abortion" control={<Radio color="primary" />}
                                            label={t('repliQuestionnaire.label.outcome.abortion')} />
                                    </RadioGroup>
                                    <FormHelperText>
                                        {props.validator.message(`pregnancy_#${i + 1}_outcome`, pregnancy.outcome, `required`)}
                                    </FormHelperText>
                                </FormControl>
                            </Grid>
                            {
                                pregnancy.outcome === "Live Birth" &&
                                <>
                                    <Grid item xs={4}>
                                        <RepLIProviderTextField
                                            label={`# ${t('repliQuestionnaire.label.outcome.liveBirth')}*`}
                                            type="number"
                                            min="0"
                                            max="10"
                                            onChange={props.onDataChange(i, 'liveBirthQty')}
                                            value={pregnancy.liveBirthQty && Math.max(0, pregnancy.liveBirthQty)}
                                            error={props.submitted && !props.validator.fieldValid(`pregnancy_#${i + 1}_live_birth`)}
                                            helperText={props.validator.message(`pregnancy_#${i + 1}_live_birth`, pregnancy.liveBirthQty, 'required|numeric|min:0,num|max:10,num')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <RepLIProviderTextField
                                            label={`# ${t('repliQuestionnaire.label.stillbirth')}*`}
                                            type="number"
                                            min="0"
                                            max="10"
                                            onChange={props.onDataChange(i, 'stillbirthQty')}
                                            value={pregnancy.stillbirthQty && Math.max(0, pregnancy.stillbirthQty)}
                                            error={props.submitted && !props.validator.fieldValid(`pregnancy_#${i + 1}_still_birth`)}
                                            helperText={props.validator.message(`pregnancy_#${i + 1}_still_birth`, pregnancy.stillbirthQty, 'required|numeric|min:0,num|max:10,num')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <RepLIProviderTextField
                                            label={`# ${t('repliQuestionnaire.label.placedAdoption')}*`}
                                            type="number"
                                            min="0"
                                            max="10"
                                            onChange={props.onDataChange(i, 'placedAdoptionQty')}
                                            value={pregnancy.placedAdoptionQty && Math.max(0, pregnancy.placedAdoptionQty)}
                                            error={props.submitted && !props.validator.fieldValid(`pregnancy_#${i + 1}_placed_for_adoption`)}
                                            helperText={props.validator.message(`pregnancy_#${i + 1}_placed_for_adoption`, pregnancy.placedAdoptionQty, 'required|numeric|min:0,num|max:10,num')}
                                        />
                                    </Grid>
                                </>
                            }

                            {/* If there is any Miscarrage or Abortion outcome we have ask the patient to hiding his information for the provider or not */}
                            {
                                pregnancy.outcome === 'Abortion' ?
                                    <>
                                        <Grid>
                                            <Typography gutterBottom>Do you want to display this information to provider?</Typography>
                                            <FormControl
                                                component="fieldset"
                                                error={props.error && !props.validator.fieldValid(`pregnancy_#${i + 1}_is_provider_view`)}
                                            >
                                                <RadioGroup row
                                                    value={pregnancy.isProviderView}
                                                    onChange={props.onDataChange(i, 'isProviderView')}
                                                >
                                                    <FormControlLabel value='true' control={<Radio color="primary" />} label="Yes" />
                                                    <FormControlLabel value='false' control={<Radio color="primary" />} label="No" />
                                                </RadioGroup>
                                                <FormHelperText error style={{ textAlign: "center" }}>
                                                    {props.validator.message(`pregnancy_#${i + 1}_is_provider_view`, pregnancy.isProviderView, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>
                                    </>
                                    : ''
                            }
                        </Grid>
                        :
                        ''
                )
            })}
            <Grid item xs={12}>
                <Button
                    fullWidth
                    variant="contained"
                    color="secondary"
                    startIcon={<AddIcon />}
                    onClick={props.onPregnancyAdd}
                >
                    {t('repliQuestionnaire.label.addPregnancy')}
                </Button>
            </Grid>
        </Grid >
    )
};

// export default multiItemQuestion(
//     Pregnancies,
//     {
//         year: '',
//         intention: '',
//         outcome: '',
//         liveBirthQty: 0,
//         stillbirthQty: 0,
//         placedAdoptionQty: 0
//     });

export default PatientPregnancyInformationForm;